<template>
  <b-overlay :show="usersLoading" class="rounded" variant="transparent">
    <template #overlay>
      <b-img
        width="100"
        :src="require('@/assets/img/brand/loader.gif')"
        alt=""
      />
    </template>
    <div class="card shadow p-3">
      <div class="card-header border-0 bg-transparent">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="mb-0 bg-transparent">
              {{ title }}
            </h3>
          </div>
        </div>
      </div>
      <b-row>
        <b-col md="2">
          <b-form-select
            v-model="filter.per_page"
            :options="[5, 10, 20, 100]"
            @input="debouncedGetAnswer()"
            size="sm"
            class="mt-2"
          ></b-form-select>
        </b-col>
        <b-col class="ml-auto col-sm-12 col-md-6 col-lg-6 mb-3">
          <b-form-group>
            <b-input-group>
              <b-form-input
                class="form-control-sm"
                v-model="filter.search"
                type="search"
                :placeholder="$t('search')"
                @input="debouncedGetAnswer()"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="12" class="table-responsive">
          <b-table
            class="align-items-center table-flush tablesorter table-text"
            hover
            :items="getCoupons ? getCoupons.data : []"
            :fields="columns"
            :per-page="getCoupons.per_page"
            :busy="
              getCoupons
                ? getCoupons.total == 0
                  ? true
                  : false
                : true
            "
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <span class="h2 text-danger">{{ $t("fail") }}</span>
              </div>
            </template>
            <template v-slot:cell(user)="data">
              {{ data.item.user.name }} {{ data.item.user.lastname }}
            </template>
            <template v-slot:cell(original_amount)="data">
              {{ data.item.original_amount }}
              {{ data.item.base_currency.symbol }}
            </template>
            <template v-slot:cell(result)="data">
              {{ data.item.result }}
              {{ data.item.converted_currency.symbol }}
            </template>
            <template v-slot:cell(fee)="data">
              {{ data.item.fee }}
              {{ data.item.converted_currency.symbol }}
            </template>
            <template v-slot:cell(status)="data">
              <b-badge
                class="text-white"
                size="lg"
                style="font-size: 10px"
                :class="colorStatus(data.item.status)"
              >
                {{ nameStatus(data.item.status) }}
              </b-badge>
            </template>
          </b-table>
          <b-pagination
            class="mt-3"
            v-if="getCoupons"
            v-model="filter.page"
            :total-rows="getCoupons.total"
            :per-page="getCoupons.per_page"
            :page-count="getCoupons.per_page"
            @input="changePage"
            first-number
            pills
            size="sm"
            align="center"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import "sweetalert2/src/sweetalert2.scss";
import _ from "lodash";
import moment from "moment";
export default {
  name: "visits-table",
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  async created() {
    this.debouncedGetAnswer = _.debounce(this.getData, 300);
    await this.getData();
    console.log(this.getCoupons);
  },
  data() {
    return {
      dataCategory: {},
      filter: {
        page: 1,
        per_page: 5,
        search: null,
      },
      moment,
    };
  },
  methods: {
    ...mapActions({
      myCoupons: "myCoupons",
    }),
    async getData() {
      await this.myCoupons(this.filter);
    },
    async changePage(value) {
      this.filter.page = value;
      this.debouncedGetAnswer();
    },
  },
  colorStatus(status) {
    let color;
    switch (status) {
      case "Pending":
        color = "bg-info";
        break;
      case "Completed":
        color = "bg-success";
        break;
      case "Rejected":
        color = "bg-danger";
        break;
    }
    return color;
  },
  nameStatus(status) {
    let name;
    switch (status) {
      case "Pending":
        name = this.$t("pending");
        break;
      case "Completed":
        name = this.$t("processed");
        break;
      case "Rejected":
        name = this.$t("rejected");
        break;
    }
    return name;
  },
  computed: {
    ...mapGetters({
      getCoupons: "getCoupons",
      usersLoading: "usersLoading",
    }),
    columns() {
      return [
        { label: this.$t("user"), key: "user", class: "text-center" },
        {
          label: this.$t("original_amount"),
          key: "original_amount",
          class: "text-center",
        },
        { label: this.$t("final_amount"), key: "result", class: "text-center" },
        { label: this.$t("fee"), key: "fee", class: "text-center" },
        { label: this.$t("status"), key: "status", class: "text-center" },
        // { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    },
  },
};
</script>